define([], function() {
    return {
        /**
         * Set a cookie
         * @param name
         * @param value
         * @param [ttl] - optional time to live in seconds; zero to remove cookie
         * @param [path] - optional path
         * @param [domain] - optional domain
         */
         set: function(name, value, ttl, path, domain) {
            var cookie = name + "=" + value;
            if (ttl) {
                var date = new Date(Date.now() + (ttl * 1000));
                var utcStr = date.toUTCString();
                cookie += "; expires=" + utcStr;
            }
            if (path) {
                cookie += "; path=" + path;
            }
            if (domain) {
                cookie += "; domain=" + domain;
            }
            cookie += ";";
            document.cookie = cookie;
        },

        /**
         * Get a cookie
         * @param name
         * @returns {string|*}
         */
        get: function (name) {
            var cookie = document.cookie;
            if (cookie) {
                var nameEQ = name + "=";
                var ca = cookie.split(';');
                for (var i = 0; i < ca.length; i++) {
                    var c = ca[i].trim();
                    if (c.indexOf(nameEQ) == 0) {
                        return c.substring(nameEQ.length);
                    }
                }
            }
        }
    };
});